import SolutionsSidebar from "pages/Solutions/SolutionsSidebar";
import { useRouteMatch } from "react-router";

export function RightSidebar() {
  const solutions = useRouteMatch("/solutions");

  return solutions != null ? <SolutionsSidebar /> : null;
}
